import { render, staticRenderFns } from "./u-mobile-header-head-basic.vue?vue&type=template&id=b78ef788&scoped=true"
import script from "./u-mobile-header-head-basic.vue?vue&type=script&lang=js"
export * from "./u-mobile-header-head-basic.vue?vue&type=script&lang=js"
import style0 from "./u-mobile-header-head-basic.vue?vue&type=style&index=0&id=b78ef788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78ef788",
  null
  
)

export default component.exports